import { NgModule } from '@angular/core';
import { PatientHistoryApiModule } from './history';
import { PatientEvaluationApiModule } from './evaluation';
import { PatientConsultationApiModule } from './consultation';
import { PatientApiService } from './patient.service';
import { EvaluationApiService } from '@api/evaluation';
import { PatientObjectiveApiModule } from './objetive';
import { NbFormFieldModule } from '@nebular/theme';

@NgModule({
  imports: [
    PatientHistoryApiModule,
    PatientEvaluationApiModule,
    PatientConsultationApiModule,
    NbFormFieldModule,
  ],
  exports: [
    PatientHistoryApiModule,
    PatientEvaluationApiModule,
    PatientConsultationApiModule,
    PatientObjectiveApiModule
  ],
  providers: [PatientApiService, EvaluationApiService],
})

export class PatientApiModule { }

